// extracted by mini-css-extract-plugin
module.exports = {"house-about":"HouseAbout_house-about___KcbT","container":"HouseAbout_container__n2mQi","description":"HouseAbout_description__RVvec","about":"HouseAbout_about___ufrX"};